<template>
  <div class="outer">
    <div class="inner">
      <img src="/homeLogo.png" alt="">
      <div class="title">{{domainInfo.bureauName}}</div>
      <div class="navs">
        <div :class="{'tab-actve': tabIndex == '1'}" @click="setTab('1')" class="tab hover-font-active">首页</div>
        <div :class="{'tab-actve': tabIndex == '2'}" @click="setTab('2')" class="tab hover-font-active">家长</div>
        <div :class="{'tab-actve': tabIndex == '3'}" @click="setTab('3')" class="tab hover-font-active">课程方</div>
        <div :class="{'tab-actve': tabIndex == '4'}" @click="setTab('4')" class="tab hover-font-active">学校</div>
        <div :class="{'tab-actve': tabIndex == '5'}" @click="setTab('5')" class="tab hover-font-active">教育局</div>
      </div>
    </div>
  </div>
</template>
<script>
import bureau from '../../api/bureau'
import globalConfig from '../../config/globle.config';

export default {
  name: 'customheader',
  data(){
    return{
      tabIndex: '4',
      domainInfo: {},
    }
  },
  methods:{
    setTab(value){
      this.tabIndex = value;
      //如果是本地环境，不做跳转
      if(globalConfig.type == 'sit') return;

      //拼接，获取站点前缀
      const siteName = location.host.split('.')[0];
      let baseUrl = '';
      if(globalConfig.type == 'beta'){
        baseUrl = 'http://' + siteName + '.beta-site.khsdb.com';
      }else{
        baseUrl = 'http://' + siteName + '.site.khsdb.com';
      }

      if(value == '1'){
        location.href = baseUrl + '/#/home'
      }else if(value == '2'){
        location.href = baseUrl + '/#/parent'
      }else if(value == '5'){
        location.href = baseUrl + '/#/login'
      }
    }
  },
  created(){
    let channel = location.hash.split('channel=');
    if(channel.length > 1){
      this.tabIndex = channel[1]
    }

    bureau.getBureau().then(res => {
      this.domainInfo = res;
    });
  }
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
  .outer{
    height: 64px;
    line-height: 64px;
    box-shadow:0px 1px 2px 0px rgba(174,176,186,0.15);
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    background: white;
    z-index: 999;
  }
  .inner{
    max-width: 1140px;
    margin: 0px auto;
    position: relative;
    text-align: left;
    >img{
      width: 140px;
      vertical-align: middle;
    }
    .title{
      padding: 0px 6px;
      vertical-align: middle;
      display: inline-block;
      color: #606266;
      font-size: 12px;
      height: 24px;
      text-align: center;
      line-height: 24px;
      margin-left: 16px;
      border-radius: 12px;
      border: 1px solid #EBEEF5;
    }
    .navs{
      vertical-align: middle;
      display: inline-block;
      position: absolute;
      right: 0px;
      text-align: right;
      .tab{
        display: inline-block;
        color: #35383E;
        width: 80px;
        margin: 0px 30px;
        text-align: center;
        font-size: 16px;
      }
    }
  }
  .tab-actve{
    color: #68CC2E !important;
  }
</style>